import { actionTypes } from '../actions/webhooks.action'
const initialState = {
    webhooks: {
        data: []
    },
    events: [],
    variables: {
        user: [],
        order: [],
        product: [],
        params: []
    },
    webhook: {
        headers_data: []
    },
    error: {},
    success: false
}

const WebhookReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.webhooks.data = state.webhooks.data.concat(payload.webhooks.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.webhooks.data.findIndex(item => item.id === payload.id)
        state.webhooks.data[index] = payload

        return {
            ...state,
            webhooks: {
                ...state.webhooks,
                data: [
                    ...[(index < 0) && payload],
                    ...state.webhooks.data
                ]
            }
        }

    case actionTypes.DESTROY:
        state.webhooks.total = state.webhooks.total - 1

        return {
            ...state,
            webhooks: {
                ...state.webhooks,
                data: state.webhooks.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            webhook: (payload === 'clear') ? {
                headers_data: []
            } : {
                ...state.webhook,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default WebhookReducer